import ApiService from "../ApiService";

const timeZoneService = {
    getScheduleRanges() {
        return ApiService.get(`/schedule-range`);
    },

    createScheduleRanges(formData) {
        return ApiService.post("/schedule-range", formData);
    },

    updateScheduleRanges(id, formData) {
        return ApiService.post(`/schedule-range/update?id=${id}`, formData);
    },
    deleteScheduleRanges(formData) {
        return ApiService.post(`/schedule-range/remove`, formData);
    }
};

export default timeZoneService;
